"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsHome = exports.ReportsHomeContent = void 0;
var react_1 = __importStar(require("react"));
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var PipelineVelocityReport_1 = require("./PipelineVelocity/PipelineVelocityReport");
var UseAnalyticsAccountSettings_1 = require("SettingsAngular/Reports/UseAnalyticsAccountSettings");
var Types_2 = require("./Types");
var TitleBar_1 = require("./TitleBar");
var inversify_react_1 = require("inversify-react");
var PipelineReportOnboarding_1 = __importDefault(require("Dashboard/PagesOnboarding/PipelineReportOnboarding"));
var c = (0, BemBuilder_1.default)("reports-home");
var ReportsHomeContent = function (_a) {
    var sessionUser = _a.sessionUser, usersList = _a.usersList, apiBaseUrl = _a.apiBaseUrl, timezone = _a.timezone, telemetry = _a.telemetry, analyticsAccountSettings = _a.analyticsAccountSettings;
    var _b = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore, isAdmin = _b.isAdmin, newFeaturesIndicatorStore = _b.useHistoryDataStore.newFeaturesIndicatorStore;
    var _c = __read((0, react_1.useState)({
        timePeriod: Types_2.TimePeriod.MONTH,
        timezone: timezone,
    }), 2), selectedTimePeriod = _c[0], setSelectedTimePeriod = _c[1];
    var defaultCurrency = analyticsAccountSettings.defaultCurrency || Types_1.CurrencyCode.AUD;
    var defaultPageCollection = analyticsAccountSettings.pageCollections.find(function (_a) {
        var isDefault = _a.isDefault;
        return isDefault;
    });
    var _d = __read((0, react_1.useState)(defaultCurrency), 2), selectedCurrency = _d[0], setSelectedCurrency = _d[1];
    var _e = __read((0, react_1.useState)(isAdmin
        ? {
            _id: Types_2.EveryoneInAccountId,
            ownerType: Types_2.OwnerFilterType.ACCOUNT,
        }
        : {
            _id: sessionUser._id,
            ownerType: Types_2.OwnerFilterType.USER,
        }), 2), selectedOwner = _e[0], setSelectedOwner = _e[1];
    var _f = __read((0, react_1.useState)(analyticsAccountSettings.defaultCleanup), 2), cleanupFilters = _f[0], setCleanupFilters = _f[1];
    var _g = __read((0, react_1.useState)(defaultPageCollection), 2), selectedPageCollection = _g[0], setSelectedPageCollection = _g[1];
    var _h = __read((0, react_1.useState)((defaultPageCollection === null || defaultPageCollection === void 0 ? void 0 : defaultPageCollection.pageFilter) || Types_2.NONE_PAGE_FILTER), 2), currentPageFilter = _h[0], setCurrentPageFilter = _h[1];
    function handleOwnerSelect(selection) {
        setSelectedOwner(selection);
        fireReportsFilterTelemetry(Types_2.ReportTelemetryEventName.ReportFilterChanged, {
            report_filter_type: "identity",
            report_filter_identity_type: selection.ownerType,
        });
    }
    function handleTimePeriodSelect(selection) {
        setSelectedTimePeriod(selection);
        fireReportsFilterTelemetry(Types_2.ReportTelemetryEventName.ReportFilterChanged, {
            report_filter_type: "time_period",
            report_filter_period: selection.timePeriod,
        });
    }
    function handleCurrencySelect(currency) {
        setSelectedCurrency(currency);
        fireReportsFilterTelemetry(Types_2.ReportTelemetryEventName.ReportFilterChanged, {
            report_filter_type: "currency",
            report_filter_currency: currency,
        });
    }
    function handlePageCollection(pageCollection) {
        setSelectedPageCollection(pageCollection);
        if (pageCollection) {
            fireReportsFilterTelemetry(Types_2.ReportTelemetryEventName.ReportCollectionChanged, {
                report_filter_collection: pageCollection.name,
                change_type: "collection",
            });
        }
    }
    function handlePageFilterChange(selection, isCollectionOnly) {
        var changeType = checkCollectionChangeType(selection);
        setCurrentPageFilter(selection);
        if (!isCollectionOnly) {
            fireReportsFilterTelemetry(Types_2.ReportTelemetryEventName.ReportCollectionChanged, {
                change_type: changeType,
            });
        }
    }
    function handleCleanupFilters(newValue) {
        var newLastEdited = newValue.lastEdited;
        if (cleanupFilters.lastEdited.enabled !== newLastEdited.enabled) {
            fireReportsFilterTelemetry(Types_2.ReportTelemetryEventName.ReportCleanupChanged, {
                change_type: "last_edited_enabled",
                change_value: newLastEdited.enabled,
            });
        }
        if (cleanupFilters.lastEdited.lastEditedDays !== newLastEdited.lastEditedDays) {
            fireReportsFilterTelemetry(Types_2.ReportTelemetryEventName.ReportCleanupChanged, {
                change_type: "last_edited_changed",
                change_value: newLastEdited.lastEditedDays,
            });
        }
        setCleanupFilters(newValue);
    }
    function fireReportsFilterTelemetry(eventName, properties) {
        telemetry.track(eventName, __assign({ report_name: Types_2.ReportsTelemetryOrigin.Pipeline }, properties), { blockIntercom: true });
    }
    function checkCollectionChangeType(currentSelection) {
        if (currentPageFilter.tags.length < currentSelection.tags.length) {
            return "tag_added";
        }
        if (currentPageFilter.tags.length > currentSelection.tags.length) {
            return "tag_removed";
        }
        if (currentPageFilter.templateIds.length < currentSelection.templateIds.length) {
            return "template_added";
        }
        if (currentPageFilter.templateIds.length > currentSelection.templateIds.length) {
            return "template_removed";
        }
        return "included_content";
    }
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: c("layout") },
            react_1.default.createElement(TitleBar_1.TitleBar, { title: "Pipeline report", sessionUser: sessionUser, usersList: usersList, selectedOwner: selectedOwner, selectedCurrency: selectedCurrency, handleOwnerSelect: handleOwnerSelect, currentPageFilter: currentPageFilter, selectedTimePeriod: selectedTimePeriod, selectedPageCollection: selectedPageCollection, cleanupFilters: cleanupFilters, handlePageFilterChange: handlePageFilterChange, handleTimePeriodSelect: handleTimePeriodSelect, handleCurrencySelect: handleCurrencySelect, handleCleanupFilters: handleCleanupFilters, handlePageCollection: handlePageCollection }),
            react_1.default.createElement(PipelineReportOnboarding_1.default, null),
            react_1.default.createElement("div", { className: c("report-container") },
                react_1.default.createElement(PipelineVelocityReport_1.PipelineVelocityReport, { selectedOwner: selectedOwner, apiBaseUrl: apiBaseUrl, selectedTimePeriod: selectedTimePeriod, selectedCurrency: selectedCurrency, currentPageFilter: currentPageFilter, cleanupFilters: cleanupFilters, telemetry: telemetry, selectedPageCollection: selectedPageCollection })))));
};
exports.ReportsHomeContent = ReportsHomeContent;
var ReportsHome = function (props) {
    var data = (0, UseAnalyticsAccountSettings_1.useAnalyticsAccountSettings)().data;
    if (data === undefined)
        return null;
    return react_1.default.createElement(exports.ReportsHomeContent, __assign({}, props, { analyticsAccountSettings: data }));
};
exports.ReportsHome = ReportsHome;
